'use client';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import getCurrentEffect from 'lowcode/common/BarWin/getCurrentEffect';
import * as CompS from 'lowcode/plugins/glo-bar-win/CompS';
import Empty from 'lowcode/utils/Empty';
import { useRouter } from 'next/router';
import { Fragment, useEffect, useState } from 'react';

const defaultTemp: any = {
    ...CompS,
};

export default function GloBarTop({ gloBarObject = {} }: { gloBarObject: any }) {
    const { locale = 'us', pathname = '' } = useRouter();
    const { theTemp = [], theData = {} } = gloBarObject;
    const [isClientA, setIsClientA] = useState(false);
    const id = theTemp[0]?.id || '';
    useEffect(() => {
        const initHandle = () => {
            EcoDesignEventsBus.on('UserHasAction-start', () => {
                if (!isClientA) {
                    setIsClientA(true);
                }
            });
            setTimeout(() => {
                if (!isClientA) {
                    setIsClientA(true);
                }
            }, 50 * 1000);
        };
        initHandle();
    }, []);

    if (!id) {
        return null;
    }
    const data = theData[id] || {};

    if (!isClientA) {
        return null;
    }

    // 根据配置的页面范围展示与不展示
    const isShowBar = getCurrentEffect(data, pathname);
    if (!isShowBar) {
        return null;
    }

    // 新版 us 首页不需要
    if (pathname === '/' && locale === 'us') {
        return null;
    }

    return (
        <div className="glo-bar-win-box">
            {theTemp?.map((item: any) => {
                const id = item.id;
                const ContentA = defaultTemp[item.name] || Empty;

                return (
                    <Fragment key={id}>
                        <ContentA id={id} data={theData[id] || {}} />
                    </Fragment>
                );
            })}
        </div>
    );
}
